(function() {
  if (typeof gsap === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  gsap.utils.toArray('.rw-fade-up').forEach(el => {
    gsap.fromTo(el,
      { opacity: 0, y: 40 },
      { opacity: 1, y: 0, duration: 0.7, ease: 'power2.out',
        scrollTrigger: { trigger: el, start: 'top 88%' }
      }
    );
  });

  gsap.utils.toArray('.rw-stagger').forEach(el => {
    gsap.fromTo(el.children,
      { opacity: 0, y: 30 },
      { opacity: 1, y: 0, duration: 0.5, stagger: 0.1, ease: 'power2.out',
        scrollTrigger: { trigger: el, start: 'top 85%' }
      }
    );
  });

  gsap.utils.toArray('.rw-count').forEach(el => {
    const target = parseFloat(el.dataset.target);
    ScrollTrigger.create({
      trigger: el, start: 'top 85%', once: true,
      onEnter: () => {
        gsap.fromTo({ val: 0 }, { val: target, duration: 1.4, ease: 'power2.out',
          onUpdate: function() {
            el.textContent = Number.isInteger(target)
              ? Math.round(this.targets()[0].val)
              : this.targets()[0].val.toFixed(1);
          }
        });
      }
    });
  });

  gsap.utils.toArray('.ig-bar-fill').forEach(el => {
    const width = el.style.width;
    el.style.width = '0%';
    gsap.to(el, {
      width: width, duration: 1.2, ease: 'power2.out',
      scrollTrigger: { trigger: el, start: 'top 88%' }
    });
  });

  gsap.utils.toArray('.rw-cards').forEach(el => {
    gsap.fromTo(el.querySelectorAll('.ig-card, .ig-stat, .ig-step'),
      { opacity: 0, y: 24, scale: 0.97 },
      { opacity: 1, y: 0, scale: 1, duration: 0.5, stagger: 0.08,
        ease: 'back.out(1.4)',
        scrollTrigger: { trigger: el, start: 'top 86%' }
      }
    );
  });
})();